import {
  AXALogoIcon,
  EnNoveltyLogoIcon,
  GrayscaleAXALogoIcon,
  GrayscaleEnNoveltyLogoIcon,
} from '@components/svgs';
import { ContainerLayout } from '@layouts';
import styles from './styles.module.scss';

export const OurPartners = () => (
  <ContainerLayout
    outerContainerClassName={styles.outerContainer}
    innerContainerClassName={styles.innerContainer}
  >
    <h2>Our Partners</h2>
    <div className={styles.iconContainer}>
      {[
        [GrayscaleAXALogoIcon, AXALogoIcon],
        [GrayscaleEnNoveltyLogoIcon, EnNoveltyLogoIcon],
      ].map(([GrayscaleIcon, Icon]) => (
        <div key={Icon.displayName} className={styles.iconWrapper}>
          <GrayscaleIcon className={styles.grayScaleIcon} />
          <Icon className={styles.icon} />
        </div>
      ))}
    </div>
  </ContainerLayout>
);

OurPartners.displayName = 'OurPartners';

export default OurPartners;
